<template>
  <div>
    <el-table
      v-loading="tableLoading"
      :data="tableData"
      :span-method="arraySpanMethod"
      max-height="1000"
      >
      <el-table-column prop="fundType" label="收款项">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="payMode" label="收款方式">
        <template slot-scope="scope">
          <span v-if="scope.row.isConfirm">{{ getPayModeText(scope.row) }}</span>
          <span class="tipRed" v-else>{{ scope.row.toast | filterToast(scope.row)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalCycle" label="总期数" v-if="scene === SCENE_TYPE.SIGN_CONTRACT">
        <template slot-scope="scope">
          <div>{{ scope.row.totalCycle }}</div>
        </template>
      </el-table-column>
      <el-table-column  prop="amount" label="收款金额">
        <template slot-scope="scope">
          <!-- 每期总金额 -->
          <template v-if="scene === SCENE_TYPE.LEASE_PLAN">
            <template v-if="scope.row.amountType === 1">
              <span v-if="scope.row.payMode === 6"> <!-- 一次性 -->
                {{ scope.row.amount | addUnit(scope.row)}}
              </span>
              <span v-else-if="scope.row.fundType === FEE_CODE_MAP.YA_JIN">
                <!-- 押金是总金额 -->
                <span>总金额 </span>
                <!-- 创建租赁方案场景下，显示配置的金额 -->
                <template v-if="scene === SCENE_TYPE.LEASE_PLAN">
                  {{ formatNumberWithCommas(scope.row.amount) }}
                </template>
                <!-- 签约订单场景下，显示总金额 -->
                <template v-else>
                  <!-- 0 固定租金 1 阶梯 2动态租金 -->
                  {{ scope.row.payPlanType === 2 ? scope.row.totalAmount :formatNumberWithCommas(scope.row.totalAmount) }}
                </template>
                <span> 元</span>
              </span>
              <span v-else>
                <!-- 其他是每期总金额 0 固定租金 1 阶梯 2动态租金 -->
                {{ scope.row.payPlanType === 2 ? leasePlanTotalFormat(scope.row.totalAmount) :`每期总金额 ${formatNumberWithCommas(scope.row.amount)} 元` }}
              </span>
            </template>
            <template v-else-if="scope.row.amountType === 2"> <!-- 日租金xxx元 x 每期自然天数 -->
              {{ `日租金 ${formatNumberWithCommas(scope.row.amount)} 元 x 每期自然天数` }}
            </template>
            <template v-else>
              {{ scope.row.amount | addUnit(scope.row)}}
            </template>
          </template>
          <template v-else>
            <template v-if="scope.row.fundType === FEE_CODE_MAP.YA_JIN && scope.row.payMode === 11">
              <span>总金额  {{ scope.row.totalAmount | addUnit(scope.row)}}</span>
            </template>
            <template v-else>
              {{ scope.row.totalAmount | addUnit(scope.row)}}
            </template>
          </template>
        </template>
      </el-table-column>
      <el-table-column prop="isConfirm" label="操作">
        <template slot-scope="scope">
          <el-button
            v-if="!scope.row.isConfirm"
            @click.native.prevent="startConfigRow(scope.$index, scope.row)"
            type="text"
            size="small"
            :disabled="isGetEndDate"
            >
            {{ isGetEndDate ? '更新中' : '点击配置' }}
          </el-button>
          <template v-else>
            <el-button
              @click.native.prevent="modificationRowConfig(scope.$index, scope.row)"
              type="text"
              size="small"
              :disabled="isGetEndDate || isGetRentPlan"
              >
              {{ (isGetEndDate || isGetRentPlan) ? '更新中' : '修改' }}
            </el-button>
            <el-button
              @click.native.prevent="moveUp(scope.$index)"
              type="text"
              size="small"
              v-if="showPrevNextBtn"
              :disabled="scope.$index === 0"
              >
              上移
            </el-button>
            <el-button
              @click.native.prevent="moveDown(scope.$index)"
              type="text"
              size="small"
              v-if="showPrevNextBtn"
              :disabled="scope.$index === tableData.length - 1"
              >
              下移
            </el-button>
            <el-button
              v-if="isDeleteFn(scope.row)"
              @click.native.prevent="deleteRowConfig(scope.$index, scope.row.name)"
              type="text"
              size="small"
              >
              删除
            </el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <!-- button -->
    <div class="planSetup-setupBox-operation">
      <el-dropdown
        :disabled="configDisabled || rentOrderFeeFilterList.length === 0"
        @command="addPaymentPlan">
        <el-button type="primary" icon="el-icon-arrow-down" icon-position="right">新增收款项</el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="item in rentOrderFeeFilterList"
            :key="item.code"
            :command="item.code"
          >{{ item.name }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <FeeConfigPopup
      v-model="popupShow"
      :step="planPopupStep"
      :configPaymentPlan="configPaymentPlanData"
      :rentCategory="rentDateInfo.rentCategory"
      :scene="scene"
      :configDisabled="configDisabled"
      :isECommerce="isECommerce"
      @getParams="getParams"
    />
  </div>
</template>
<script>
import { getAccruedPlanStatistic, orderAccruedplanvalidAccruedPlanAmountApi } from '@/api/domain/orders.js'
import orderConfigFn from '@/pages/orders/config/index.js'
import { isNewOverdueForRentPlanConfig } from '@/pages/utils/overdue'
import { CATEGORY_CODE_MAP, CATEGORY_FEE_MAP, FEE_CODE_MAP, PAYMODE_CODE_MAP, PAYPOSY_CODE_MAP } from '@/store/dict/rentPlanDict.js'
import selectOption from '@/store/dict/selectOptionDict.js'
import { formatNumberWithCommas } from '@/utils'
import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'
import { CHECK_CONF, SCENE_TYPE } from './config'
import FeeConfigPopup from './FeeConfigPopup.vue'
import { getEnum } from '@/api/global.js'
import { PAY_MODE } from '@/config/rentConfig.js'

export default {
  name: 'RentPlanConfig',
  components: {
    FeeConfigPopup,
  },
  props: {
    rentDateInfo: { // 包含合同起止时间、租期、赠送天数、类别
      type: Object,
      default: () => ({
        rentCategory: 1, // 类别 - 默认租车
        rentPeriod: null, // 租赁周期
        presentDays: null, // 赠送天数
        rentPeriodType: null,
        startStopDate: [], // 收款起止日期
        signDate: null, // 签署日期
        contractDateText: '', // 合同起止日期文本
        rentPeriodText: '', // 租赁周期文本
        presentDaysText: '', // 赠送天数文本
        disabled: false, // 是否禁止修改
        payMode: '', // 收款方式
        endDate: '', // 租用结束日
        isEndDateMode: false, // 是否为结束日模式
      }),
    },
    defaultTableData: { // 支付计划数据
      type: Array,
      default: () => [],
    },
    specialType: {
      type: Number,
      default: 1,
    },
    // 场景
    scene: {
      type: String,
      default: SCENE_TYPE.LEASE_PLAN,
    },
    // 是否禁用配置
    configDisabled: {
      type: Boolean,
      default: false,
    },
    // 押金费项配置，会在押金切换时强行
    // 覆盖defaultTableData中的押金配置
    depositConfig: {
      type: Object,
    },
    // 判断是否为商城单，商城单已添加费项不允许修改，只能添加后置费项
    isECommerce: {
      type: Boolean,
      default: false,
    },
    // 正在获取合同截止日期
    isGetEndDate: {
      type: Boolean,
      default: false,
    },
    // 正在生成支付计划
    isGetRentPlan: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const { m_weekList } = orderConfigFn.call(this)
    return {
      FEE_CODE_MAP,
      SCENE_TYPE,
      formatNumberWithCommas,
      m_weekList: this.formatEnumeration(m_weekList),
      selectOption,
      addFundType: '',
      tableData: [],
      tableLoading: false,
      rentOrderFeeFilterList: [],
      // 弹窗相关
      popupShow: false,
      configPaymentPlanData: {
        formData: {},
        customFlag: 0, // 是否为后置费项，1-后置费项，0-非后置费项
        feeName: '', // 费项名称
      },
      planPopupStep: 1, // 设置支付计划组件步骤
      customFeeList: [], // 后置费项
    }
  },
  filters: {
    // 增加单位
    addUnit(val, rowData) {
      const { payPlanType } = rowData
      if (isNewOverdueForRentPlanConfig(rowData)) {
        return `未付租金*${rowData.lateFeeProportion}%/日`
      } else if (val === 0 || val) {
        // 0 固定租金 1 阶梯 2动态租金
        return `${payPlanType === 2 ? val : formatNumberWithCommas(val)} 元`
      } else {
        return '--'
      }
    },
    // 固定金额阶梯
    piecewiseFormate(val) {
      const spliceText = val.reduce((total, item) => {
        total = `${total + item.startMonth}-${item.endMonth}月 ${formatNumberWithCommas(item.amount)} 元；`
        return total
      }, '')
      return spliceText
    },
    // 日租金模式阶梯
    dailyPiecewiseFormate(val) {
      const spliceText = val.reduce((total, item) => {
        total = `${total + item.startMonth}-${item.endMonth}月 日租金 ${formatNumberWithCommas(item.amount)} 元 x 当期自然天数；`
        return total
      }, '')
      return spliceText
    },
    filterToast(val, rowData) {
      const text = `${val}请点击配置${rowData.name}规则`
      return text
    },
  },
  computed: {
    ...mapState({
      paymentMethods: (state) => state.global.paymentMethods, // 收款方式
      orderSignRentFee: (state) => state.rentPlan.orderSignRentFee, // 租车费项
      orderSignPurchaseFee: (state) => state.rentPlan.orderSignPurchaseFee, // 已租代购费项
      orderSignCooperateFee: (state) => state.rentPlan.orderSignCooperateFee, // 司机合作模式费项
    }),
    // 是否显示上移下移按钮
    showPrevNextBtn() {
      return this.scene === SCENE_TYPE.SIGN_CONTRACT
    },
  },
  watch: {
    rentDateInfo: {
      handler(val) {
        this.$emit('rentCategoryType', val.rentCategory)
        // 请求费项list
        this.queryFeeList()
      },
      deep: true,
      immediate: true,
    },
    defaultTableData: {
      handler(val) {
        if (val.length) {
          this.tableData = cloneDeep(val)
          this.tableData.forEach((item) => {
            item.isPayPostCustom = item.payPost === PAYPOSY_CODE_MAP.CUSTOM
            if (item.payPlanType === 2) {
              item.totalAmount = item.payAmount || item.totalAmount
            }
          })
        }
      },
      immediate: true,
      deep: true,
    },
    tableData: {
      handler() {
        this.queryFeeList()
      },
      deep: true,
    },
    /**
     * 只会发生在押金平移手动操作变化时，所以
     * 1. 不需要也不要immediate
     * 2. 不需要关注页面初始化时的逻辑
     */
    depositConfig: {
      handler(val) {
        this.tableData = this.tableData.map((item) => {
          if (item.fundType === val.fundType) {
            return val
          }
          return item
        })
      },
    },
    isECommerce(val) {
      // 商城单只能添加后置费项
      if (val) {
        this.setPersonSingSelectList([])
      }
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.$store.dispatch('getPaymentMethods', { type: 'payMode' }) // 获取收款方式
    },
    // 合并列
    arraySpanMethod({ row, columnIndex }) {
      const columnLength = this.scene === SCENE_TYPE.SIGN_CONTRACT ? 5 : 4
      if (row.isConfirm === false) {
        if (columnIndex === 1) {
          return [1, columnLength - 2]
        } else if (columnIndex > 0 && columnIndex < columnLength - 1) {
          return [1, 0]
        }
        return [1, 1]
      }
    },
    // 请求费项list
    queryFeeList() {
      if (!this.rentDateInfo.rentCategory) {
        return
      }
      this.tableLoading = true
      const someFeeList = this[CATEGORY_FEE_MAP[Number(this.rentDateInfo.rentCategory)]]
      if (!someFeeList || !someFeeList.length) {
        // 根据【类别】获取不同类别对应的费项
        this.$store.dispatch('getFeeList', { type: CATEGORY_FEE_MAP[Number(this.rentDateInfo.rentCategory)] }).then((res) => {
          this.tableLoading = false
          this.setSelectList(res.data)
        }).catch(() => {
          this.tableLoading = false
          this.$set(this, 'rentOrderFeeFilterList', [])
        })
      } else {
        this.tableLoading = false
        this.setSelectList(someFeeList)
      }
    },
    // 设置新增收款项list
    setSelectList(feeList) {
      // 商城单只能添加后置费项
      if (this.isECommerce) {
        this.setPersonSingSelectList([])
        return
      }
      if (this.scene === SCENE_TYPE.SIGN_CONTRACT) {
        this.setPersonSingSelectList(feeList)
        return
      }
      // 过滤掉table中已经有的费项
      feeList = feeList.filter((it) => !this.tableData.some((i) => Number(i.fundType) === it.code))
      if (Number(this.rentDateInfo.rentCategory) !== CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) { // 类别为【租车】和【司机合作模式】，新增费项的list为过滤掉必填项
        this.$set(this, 'rentOrderFeeFilterList', feeList.filter((it) => !it.required))
      } else { // 类别为【以租代购】
        // 新增费项的list为过滤掉table中已经有的费项（首付款, 租金, 全款）
        const filterFeeCodes = [FEE_CODE_MAP.SHOU_FU_KUAN, FEE_CODE_MAP.ZU_JIN, FEE_CODE_MAP.QUAN_KUAN] // 首付款, 租金, 全款
        filterFeeCodes.forEach((feeCode) => {
          if (this.tableData.some((i) => Number(i.fundType) === feeCode)) {
            feeList = feeList.filter((it) => Number(it.code) !== feeCode)
          }
        })
        this.$set(this, 'rentOrderFeeFilterList', feeList)
      }
    },
    // 个人签约提车费项列表设置
    async setPersonSingSelectList(feeList) {
      let tempFeeList = feeList
      // 拼接后置费项
      if (!this.customFeeList.length) {
        await this.getCustomFeeListFromEnum()
      }
      tempFeeList = tempFeeList.concat(this.customFeeList)
      // 过滤掉table中已经有的费项
      tempFeeList = tempFeeList.filter((it) => !this.tableData.some((i) => Number(i.fundType) === it.code))
      this.$set(this, 'rentOrderFeeFilterList', tempFeeList)
    },
    // 校验必填费项
    validRequiredFee() {
      if (!this.tableData.length) {
        return false
      } else if (!this.tableData.some((i) => i.required)) {
        return false
      }
      return true
    },
    // 已添加的是否可删除 - 【以租代购】互斥逻辑
    isDeleteFn(rowData) {
      if (this.rentDateInfo.rentCategory !== CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) { // 除类别为 【已租代购】，其他类别添加的收款项中，非必填字段可删除
        return (!rowData.required)
      } else if (Number(rowData.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN) { // 24-首付款
        return (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN)) // 15-全款
      } else if (Number(rowData.fundType) === FEE_CODE_MAP.ZU_JIN) { // 1-租金
        return (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN)) // 15-全款
      } else if (Number(rowData.fundType) === FEE_CODE_MAP.QUAN_KUAN) { // 15-全款
        return (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN || Number(i.fundType) === FEE_CODE_MAP.ZU_JIN))
      } else {
        return (!rowData.required)
      }
    },
    // 点击配置
    startConfigRow(_, rowData) {
      const nextFlag = this.beforeValid('add')
      if (!nextFlag) return
      this.planPopupStep = 1
      let { payMode } = this.rentDateInfo
      // 押金、首付款、全款、尾款时收款方式默认为一次性，不使用外面的收款方式
      const { YA_JIN, SHOU_FU_KUAN, WEI_KUAN, QUAN_KUAN } = FEE_CODE_MAP
      if ([YA_JIN, SHOU_FU_KUAN, WEI_KUAN, QUAN_KUAN].includes(Number(rowData.fundType))) {
        payMode = PAY_MODE.DISPOSABLE
      }
      const formData = {
        ...rowData,
        rentPeriod: this.rentDateInfo.rentPeriod,
        rentPeriodType: this.rentDateInfo.rentPeriodType,
        startTime: this.rentDateInfo.startStopDate?.[0],
        endTime: this.rentDateInfo.startStopDate?.[1],
        isTranDeposit: Boolean(this.rentDateInfo.isTranDeposit),
        payMode,
      }
      this.configPaymentPlanData.formData = formData
      this.configPaymentPlanData.feeName = rowData.name
      this.configPaymentPlanData.customFlag = rowData.fundType === PAY_MODE.POSTPAID_ITEM ? 1 : 0
      this.popupShow = true
    },
    // 新增收款项
    addPaymentPlan(e) {
      this.addFundType = e
      // 新增收款项之前的校验
      const nextFlag = this.beforeValid('add')
      if (!nextFlag) return
      if (!this.addFundType) return
      this.planPopupStep = 1
      const hasSomeFundType = this.tableData.find((i) => i.fundType === this.addFundType)
      if (hasSomeFundType) {
        this.$message.error(`收款项“${hasSomeFundType.name}”已在支付计划中，请勿重复添加`)
        return
      }
      let { payMode } = this.rentDateInfo
      // 押金、首付款、全款、尾款时收款方式默认为一次性，不使用外面的收款方式
      const { YA_JIN, SHOU_FU_KUAN, WEI_KUAN, QUAN_KUAN } = FEE_CODE_MAP
      if ([YA_JIN, SHOU_FU_KUAN, WEI_KUAN, QUAN_KUAN].includes(Number(this.addFundType))) {
        payMode = PAY_MODE.DISPOSABLE
      }
      const formData = {
        fundType: Number(this.addFundType),
        rentPeriod: this.rentDateInfo.rentPeriod,
        rentPeriodType: this.rentDateInfo.rentPeriodType,
        startTime: this.rentDateInfo.startStopDate?.[0],
        endTime: this.rentDateInfo.startStopDate?.[1],
        isTranDeposit: Boolean(this.rentDateInfo.isTranDeposit),
        payMode,
      }

      this.configPaymentPlanData.formData = formData
      // 判断是否为后置费项
      const selectedFeeItem = this.rentOrderFeeFilterList.find((i) => i.code === this.addFundType)
      this.configPaymentPlanData.customFlag = (selectedFeeItem && selectedFeeItem.customFlag) || 0 // 1-后置费项，0-非后置费项
      this.configPaymentPlanData.feeName = selectedFeeItem?.name || ''
      this.popupShow = true
      this.addFundType = null // 添加完后置空
    },
    // 修改配置
    modificationRowConfig(_, rowData) {
      const nextFlag = this.beforeValid('edit')
      if (!nextFlag) return
      if (this.scene === SCENE_TYPE.LEASE_PLAN) {
        // 租赁方案场景下，默认进入配置金额的步骤
        this.planPopupStep = 1
      } else {
        // 签约订单场景下，根据是否是新滞纳金进入不同的步骤
        this.planPopupStep = isNewOverdueForRentPlanConfig(rowData) ? 1 : 2
      }
      const { fundType, receivableTotalAmount } = rowData
      const modifiedFeeItem = this.tableData.some((i) => i.fundType === fundType)
      if (!modifiedFeeItem) {
        return false
      }

      const { rentPeriod, rentPeriodType, startStopDate } = this.rentDateInfo
      const formData = {
        ...rowData,
        rentPeriod,
        rentPeriodType,
        startTime: startStopDate?.[0],
        endTime: startStopDate?.[1],
        receivableTotalAmount,
        isTranDeposit: Boolean(this.rentDateInfo.isTranDeposit),
      }
      this.configPaymentPlanData.formData = formData
      this.configPaymentPlanData.tableData = rowData.items
      // 判断是否为后置费项
      this.configPaymentPlanData.customFlag = rowData.payMode === PAY_MODE.POSTPAID_ITEM ? 1 : 0 // 1-后置费项，0-非后置费项
      this.configPaymentPlanData.feeName = rowData?.name || ''
      this.popupShow = true
    },
    // 删除配置
    deleteRowConfig($index, feeName) {
      this.$confirm(`收款项${feeName}及相关款项配置将从租赁账单中删除，确定?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.tableData.splice($index, 1)
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      }).catch(() => {})
    },
    // 新增收款项或配置支付计划之前的校验
    beforeValid(messageFlag) {
      const config = CHECK_CONF[this.scene]
      const keyConfig = config[messageFlag]
      for (const key in keyConfig) {
        if (keyConfig[key].validate(this.rentDateInfo)) {
          this.$message.error(keyConfig[key].message(this.rentDateInfo))
          // 此时需要锚点到【预计租赁周期】的位置上去
          this.$emit('autoAnchor', false)
          return false
        }
      }
      return true
    },
    // 表单校验，若通过校验，返回table数据，若未通过，返回false
    getFormData() {
      // 表格部分的收费项校验
      const requiredValidRes = this.validRequiredFee()
      if (!requiredValidRes) {
        this.$message.error('费项配置无必填项！请检查')
        return false
      }
      if (this.rentDateInfo.rentCategory === CATEGORY_CODE_MAP.YI_ZU_DAI_GOU) { // 类别为以租代购
        // 如果有「全款」费项，校验 是否有「首付款」或「租金」或「尾款」，如果有则阻断提交
        if (this.tableData.find((i) => Number(i.fundType) === FEE_CODE_MAP.QUAN_KUAN)) { // 15-全款
          if (this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN || Number(i.fundType) === FEE_CODE_MAP.ZU_JIN || Number(i.fundType) === FEE_CODE_MAP.WEI_KUAN)) { // 24-首付款 1-租金 25-尾款
            this.$message.error('签约时，全款 和 首付款/租金/尾款 不能同时收取，请检查修复后重新提交')
            return false
          }
        } else if (!this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.SHOU_FU_KUAN) || !this.tableData.some((i) => Number(i.fundType) === FEE_CODE_MAP.ZU_JIN)) { // 1-租金 24-首付款
          // 如果没有「全款」，校验 「首付款」和「租金」 为必填项，都必须填全
          this.$message.error('首付款和租金为必填项，都必须填全')
          return false
        }
      }
      // 添加的费项都配置完成才能返回true
      const tableDataHasNoConfig = this.tableData.some((i) => i.isConfirm === false)
      if (tableDataHasNoConfig) {
        const noConfigFeeNames = this.tableData.reduce((total, item) => {
          if (!item.isConfirm) {
            total = total.concat([`【${item.name}】`])
          }
          return total
        }, [])
        this.$message.error(`请将${noConfigFeeNames.toString()}费项配置完成`)
        return false
      }
      return this.tableData.map((item) => {
        return {
          ...item,
          planAmount: item.amount,
        }
      })
    },
    disposeOverdueRowData(item) {
      // 收款方式 为 一次性
      item.payMode = PAYMODE_CODE_MAP.DISPOSABLE
      item.payDate = null
    },
    // 点击弹窗的确定，获取配置的表单
    getParams(value) {
      const funName = CHECK_CONF[this.scene].handleData
      this[funName](value)
    },
    // 租赁方案场景获取配置
    getLeasePlanData(data) {
      // 费项列表中已添加
      if (this.tableData.some((i) => i.fundType === data.formData.fundType)) {
        const newTableData = this.tableData.map((item) => {
          if (item.fundType === data.formData.fundType) {
            const nite = Object.assign({}, item, data.formData)
            nite.isConfirm = true
            nite.items = data.items
            // 如果是新滞纳金 收款金额列展示 费率 发车前收款展示 发车前不收 尾期租金规则 null (修改时)
            if (isNewOverdueForRentPlanConfig(data.formData)) {
              this.disposeOverdueRowData(nite)
            }
            // 判断如果动态租金的情况下需要自己拼接一下
            if (nite.payPlanType === 2) {
              nite.totalAmount = nite.dynamicList.reduceRight((pre, cur, index) => {
                return index === 0 ? `${pre + cur.amount}元` : `${pre + cur.amount}/`
              }, '')
            }
            return nite
          } else {
            return item
          }
        })
        this.$set(this, 'tableData', newTableData)
      } else {
        // 费项类表中未添加
        const fee = this[CATEGORY_FEE_MAP[this.rentDateInfo.rentCategory]].find((i) => {
          return Number(i.code) === Number(data.formData.fundType)
        })
        const addFeeItem = {
          ...data.formData,
          fundType: fee.code,
          name: fee.name,
          required: fee.required,
          toast: fee.toast,
          items: data.items, // 费项支付计划
        }
        addFeeItem.isConfirm = true
        // 如果是新滞纳金 收款金额列展示 费率 发车前收款展示 发车前不收 尾期租金规则 null (添加时)
        if (isNewOverdueForRentPlanConfig(data.formData)) {
          this.disposeOverdueRowData(addFeeItem)
        }
        this.tableData.push(addFeeItem)
      }
      this.$emit('tableDataChange', this.tableData)
    },
    // 签约场景获取配置
    async getSignContractData(data) {
      // 后置费项单独处理
      if (data.customFlag === 1) {
        this.handleCustomFeeData(data)
        return
      }
      this.tableLoading = true
      // 获取支付计划汇总数据
      const res = await getAccruedPlanStatistic({ accruedPlanList: data.items })
      this.tableLoading = false
      if (res.code === 1) {
        data.formData.totalCycle = res.data?.totalCycle // 总期数
        data.formData.totalAmount = res.data?.totalAmount // 计算得到的总金额
      }
      // 费项列表中已添加
      if (this.tableData.some((i) => i.fundType === data.formData.fundType)) {
        const newTableData = this.tableData.map((each) => {
          if (each.fundType === data.formData.fundType) {
            const nite = Object.assign({}, each, data.formData)
            nite.isConfirm = true
            nite.items = data?.items
            // 如果是新滞纳金 收款金额列展示 费率 发车前收款展示 发车前不收 尾期租金规则 null (修改时)
            if (isNewOverdueForRentPlanConfig(data.formData)) {
              this.disposeOverdueRowData(nite)
            }
            each.advancePayment = data.formData.advancePayment
            each.amount = data.formData.amount
            return nite
          } else {
            return each
          }
        })
        this.$set(this, 'tableData', newTableData)
      } else { // 费项列表中未添加
        const fee = this[CATEGORY_FEE_MAP[this.rentDateInfo.rentCategory]].find((i) => {
          return Number(i.code) === data.formData.fundType
        })
        const addFeeItem = {
          ...data.formData,
          fundType: fee.code, // 费项code
          name: fee.name, // 费项名
          required: fee.required, // 是否必填 boolean
          toast: fee.toast, // 费项 toast
          items: data.items, // 费项支付计划
        }
        addFeeItem.isConfirm = true
        // 如果是新滞纳金 收款金额列展示 费率 发车前收款展示 发车前不收 尾期租金规则 null (添加时)
        if (isNewOverdueForRentPlanConfig(data.formData)) {
          this.disposeOverdueRowData(addFeeItem)
        }
        this.tableData.push(addFeeItem)
      }
      this.$emit('tableDataChange', this.tableData)
    },
    getPayDate(rowData) {
      if (isNewOverdueForRentPlanConfig(rowData)) {
        return '--'
      } else {
        return '订单收款起始日'
      }
    },
    orderAccruedplanvalidAccruedPlanAmount(accruedPlanParamList) {
      return orderAccruedplanvalidAccruedPlanAmountApi({
        accruedPlanParamList,
        rentCategory: this.rentDateInfo.rentCategory,
      })
    },
    getTableData() {
      return this.tableData
    },
    // 上移
    moveUp(index) {
      if (index === 0) return; // 第一行无需上移
      // 解构交换数组中 index 和 index-1 的元素
      [this.tableData[index - 1], this.tableData[index]] = [this.tableData[index], this.tableData[index - 1]]
      // 重新赋值数组（触发视图更新，某些场景下需要）
      this.tableData = [...this.tableData]
      this.$emit('tableDataChange', this.tableData)
    },
    // 下移
    moveDown(index) {
      if (index === this.tableData.length - 1) return; // 最后一行无需下移
      // 解构交换数组中 index 和 index+1 的元素
      [this.tableData[index], this.tableData[index + 1]] = [this.tableData[index + 1], this.tableData[index]]
      // 重新赋值数组（触发视图更新）
      this.tableData = [...this.tableData]
      this.$emit('tableDataChange', this.tableData)
    },
    // 获取后置费项
    async getCustomFeeListFromEnum() {
      const { code, data } = await getEnum({
        type: 'withholdCustomFee',
      })
      if (code === 1) {
        this.customFeeList = data.map((item) => {
          return {
            name: item.name,
            code: item.code,
            customFlag: 1,
          }
        })
      }
    },
    // 收款项显示中文
    enumerationFilter(val, list) {
      const name = (list && list.find((item) => {
        return Number(item.code) === Number(val)
      })?.name) || '--'
      return name
    },
    // 后置费项处理
    handleCustomFeeData(data) {
      // 费项列表中已添加
      if (this.tableData.some((i) => i.fundType === data.formData.fundType)) {
        const newTableData = this.tableData.map((each) => {
          if (each.fundType === data.formData.fundType) {
            const nite = Object.assign({}, each, data.formData)
            nite.isConfirm = true
            return nite
          } else {
            return each
          }
        })
        this.$set(this, 'tableData', newTableData)
      } else { // 费项列表中未添加
        const addFeeItem = {
          ...data.formData,
          name: data.name, // 费项名
        }
        addFeeItem.isConfirm = true
        this.tableData.push(addFeeItem)
      }

      this.$emit('tableDataChange', this.tableData)
    },
    getPayModeText(row) {
      const { payMode, payModeText } = row
      if (payMode) {
        return this.enumerationFilter(payMode, this.paymentMethods)
      }
      return payModeText
    },
    leasePlanTotalFormat(totalAmount) {
      const list = totalAmount.replace(/元/g, '').split('/')
      if (list.length > 1) {
        const min = Math.min(list[0], list[list.length - 1])
        const max = Math.max(list[0], list[list.length - 1])
        return `${min}~${max}元`
      }
      return list[0] || ''
    },
  },
}
</script>
<style lang="scss" scoped>
.planSetup-setupBox-operation {
  margin-top: 20px;
  margin-bottom: 20px;
}
.tipRed{
  color: #FF5964;
}
::v-deep .tran-deposit-radio {
  .el-form-item__label {
    width: auto;
    min-width: 150px;
    max-width: 300px;
    white-space: pre-line;
  }
}
::v-deep .el-dropdown [disabled] {
  background: #4894FF;
  color: #fff;
  border-color: transparent;
}
</style>
